import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f76a7dd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rating" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RatingForm = _resolveComponent("RatingForm")!
  const _component_RatingList = _resolveComponent("RatingList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RatingForm),
    _createVNode(_component_RatingList)
  ]))
}